import GoogleBusiness from './google-business';
import Polygraphy from './polygraphy';

export default {
  GoogleBusiness,
  Polygraphy,
};
